import { Injectable } from '@angular/core';
import { IconDefinition } from '@fortawesome/pro-thin-svg-icons';
import * as thinIcons from '@fortawesome/pro-thin-svg-icons';

/**
 * The Font Awesome Pro thin catalogue, enumerated once from the installed package.
 *
 * Reflection icons are stored as names rather than imports, so the whole pack has to
 * be reachable at runtime -- which is why this is a namespace import rather than named
 * ones, and why the pack is not tree-shaken.
 */
@Injectable({ providedIn: 'root' })
export class PipeIconsService {
  private _allThinIcons!: IconDefinition[];
  private _iconNames!: string[];

  constructor() {
    this._allThinIcons = this.extractIconsFromPack(thinIcons);
    this._iconNames = this._allThinIcons.map((icon) => icon.iconName as string);
  }

  private extractIconsFromPack(pack: any): IconDefinition[] {
    return Array.from(
      new Set(
        Object.keys(pack)
          .filter((key) => pack[key].iconName) // Check if the property has an iconName, which is typical of Font Awesome icons
          .map((key) => pack[key] as IconDefinition),
      ),
    );
  }

  get allIcons() {
    return this._allThinIcons;
  }

  /** Names only, for pickers that browse the catalogue rather than render from it. */
  get allIconNames(): readonly string[] {
    return this._iconNames;
  }
}
